import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import common from './translations/en/common.json';
import navigation from './translations/en/navigation.json';
import dashboard from './translations/en/dashboard.json';
import processes from './translations/en/processes.json';
import patients from './translations/en/patients.json';
import validation from './translations/en/validation.json';
import settings from './translations/en/settings.json';
import tasks from './translations/en/tasks.json';
import surveys from './translations/en/surveys.json';
import callSheets from './translations/en/callSheets.json';
import targetTaskTime from './translations/en/target_task_time.json';
import user from './translations/en/user.json';
import tenants from './translations/en/tenants.json';
import doctors from './translations/en/doctors.json';
import operatories from './translations/en/operatories.json';
import treatments from './translations/en/treatments.json';
import groups from './translations/en/groups.json';
import alertAlarm from './translations/en/alert_alarm.json';
import systemConfiguration from './translations/en/system_configuration.json';
import improve from './translations/en/improve.json';

const resources = {
  en: {
    common,
    navigation,
    dashboard,
    processes,
    patients,
    validation,
    settings,
    tasks,
    surveys,
    callSheets,
    targetTaskTime,
    user,
    tenants,
    doctors,
    operatories,
    treatments,
    groups,
    alertAlarm,
    systemConfiguration,
    improve
  }
};
i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  interpolation: {
    escapeValue: false
  }
});

export default i18n;
